import dayjs from 'dayjs'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'

export const formatDateForApi = (date: string): string => {
  return dayjs(date).format(DATE_FORMAT_LIST.YEAR_FULL_DATE)
}
